export default "__VITE_ASSET__DIxX7epQ__"